<script>
  import { onMount } from "svelte";
  import {push, pop, replace} from 'svelte-spa-router';
  import {link} from 'svelte-spa-router';
  import Menu from './Menu.svelte';

  const urlpsw = `/ianua/user/passwd`;
  const urllog = `/ianua/bin/log`;
  
  let _log = '';
  let _err = '';
  let q = 10;
  let s = 0;
  
  let pswdo = '';
  let pswd1 = '';
  let pswd2 = '';
  
  // popola
  onMount(async () => {
    await fetch(urllog + '/' + q)
      .then(r => r.json())
      .then(data => {
	_log = data;
      });
  })

  async function logPrev() {
    if (s < 0) {
      s = 0;
      return;
    }
    await fetch(urllog + '/' + q + '/' + s)
      .then(r => r.json())
      .then(data => {
	s = s - q;
	_log = data;
      });
  };

  async function logNext() {
    if (s < 0) {
      s = q;
    }
    await fetch(urllog + '/' + q + '/' + s)
	.then(r => r.json())
      .then(data => {
	s = s + q;
	_log = data;
      });
  };

  async function passwd(){
    // https://web.dev/articles/fetch-api-error-handling
    // https://dev.to/dionarodrigues/fetch-api-do-you-really-know-how-to-handle-errors-2gj0
    let json;

    if (pswdo === "") {
      return;
    }

    if (pswdo === pswd1) {
      _err = 'Le password nuove e vecchie sono uguali';
      return;
    }

    if (pswd1 !== pswd2) {
      _err = 'Le nuove password non corrispondono';
      return;
    }
    
    const data = new FormData();
    data.append('pswdo', pswdo);
    data.append('pswdn', pswd1);
    
    try {
      const res = await fetch(urlpsw, {
	method: 'POST',
	body: data,
      });
      if (res.ok) {
	json = await res.json();
      } else {
	if (res.status === 401) push('/login');
	if (res.status === 404) throw new Error('Not found');
	throw new Error(res.status);
      }
    } catch(err) {
      _err = err;
    };

    if(json) {
      _err = 'Password aggiornata';
      // push('/');
    }
  };

  function reset() {
    _err = '';
    pswdo = '';
    pswd1 = '';
    pswd2 = '';
    return;
  };
  

</script>

<Menu />

<div id="main" class="wrapper style1">
  <div class="container">
    <section id="content">
      
      {#if _log}
	<h3>Ultime attività</h3>
	<div class="table-wrapper">
	  <table>
	    <thead>
	      <tr>
		<th>data</th>
		<th>autore</th>
		<th>stato</th>
		<th>descrizione</th>
	      </tr>
	    </thead>
	    <tbody>
	      {#each _log as l}
		<tr>
		  <td>{l.ts}</td>
		  <td>{l.name}</td>
		  <td>{l.sta}</td>
		  <td>{l.log}</td>
		</tr>
	      {/each}
	    </tbody>
	  </table>
	</div>

	<div class="row">
	  <div class="col-3"> </div>
	  <div class="col-6 col-12-xsmall">
	    <ul class="actions fit small">
	      <li><a on:click|preventDefault="{logPrev}" class="button fit small icon solid fa-long-arrow-alt-left"></a></li>
	      <li><a on:click|preventDefault="{logNext}" class="button fit small icon solid fa-long-arrow-alt-right"></a></li>
	    </ul>
	  </div>
	</div>
	
	<hr />
      {/if}
      
      <h3>Cambio password</h3>
      <form method="post">
	<div class="row gtr-uniform gtr-50">
	  <div class="col-4 col-12-xsmall">
	    <input bind:value="{pswdo}" type="password" name="pswdo" id="pswdo" placeholder="Vecchia password" />
	  </div>
	  <div class="col-4 col-12-xsmall">
	    <input bind:value="{pswd1}" type="password" name="pswd1" id="pswd1" placeholder="Nuova password" />
	  </div>
	  <div class="col-4 col-12-xsmall">
	    <input bind:value="{pswd2}" type="password" name="pswd2" id="pswd2" placeholder="Ripeti la nuova password" />
	  </div>
	  <div class="col-12">
	    <ul class="actions">
	      <li><input on:click|preventDefault="{passwd}" type="submit" value="Invia" class="primary" /></li>
	      <li><input on:click|preventDefault="{reset}" type="reset" value="Reset" /></li>
	    </ul>
	  </div>
	</div>
      </form>
      {#if _err}
	<div class="row gtr-uniform gtr-50">
	  <div class="col-12 col-12-xsmall">
	    <strong class="warning">{_err}</strong>
	  </div>
	</div>
      {/if}

    </section>
  </div>
</div>
